export default __webpack_public_path__ + "static/media/CL04.2.9b5c379f.mp3";